import { render } from "./AppointmentFilters.vue?vue&type=template&id=8a5be472"
import script from "./AppointmentFilters.vue?vue&type=script&lang=js"
export * from "./AppointmentFilters.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__